// app.routes.ts
import { Routes } from '@angular/router';
import { authGuard, loginGuard } from './features/auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [loginGuard],
    loadComponent: () =>
      import('./features/auth/pages/login/login.page').then(m => m.LoginPage),
  },
  {
    path: 'forgot-password',
    canActivate: [loginGuard],
    loadComponent: () =>
      import('./features/auth/pages/forgot-password/forgot-password.page').then(m => m.ForgotPasswordPage),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./features/auth/pages/reset-password/reset-password.page').then(m => m.ResetPasswordPage),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./shell/layout-shell.component').then(m => m.LayoutShellComponent),

    // ✅ placeholder: matchea cualquier deep-link mientras se inyectan rutas dinámicas
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/pages/dashboard/dashboard.page').then(m => m.DashboardPage)
      },
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: '**',
        data: { __dynamicPlaceholder: true },
        loadComponent: () =>
          import('./shell/content-skeleton.component').then(m => m.ContentSkeletonComponent),
      },
    ],
  },

  // ✅ no mandes a login acá, porque te mata deep-links
  // dejalo como not-found o redirect al root
  { path: '**', redirectTo: '' },
];
